export const translations = {
  no: {
    // Navbar
    nav_menu: "Meny",
    nav_order: "Bestill",
    nav_booking: "Reservasjon",
    nav_catering: "Catering",
    nav_giftcard: "Gavekort",
    nav_gallery: "Galleri",
    nav_about: "Om Oss",
    nav_contact: "Kontakt",

    // Homepage Hero
    hero_subtitle: "Smak av India",
    hero_menu_btn: "Se Meny",
    hero_booking_btn: "Reserver Bord",

    // Homepage About
    home_about_tag: "Om Oss",
    home_about_title: "Opplev Den Ekte Smaken av India",
    home_about_p1: "Velkommen til Masala Indisk Restaurant og Bar – hvor tradisjon, krydder og lidenskap forenes. Vi serverer autentiske retter laget med de fineste ingrediensene og tidløse oppskrifter fra det indiske kjøkken.",
    home_about_p2: "Med over 30 års erfaring inviterer vi deg på en kulinarisk reise gjennom India – der hver rett er laget med kjærlighet, presisjon og stolthet.",

    // Homepage Popular
    home_popular_tag: "Populære Retter",
    home_popular_title: "Våre Populære Retter",
    home_popular_explore: "Utforsk Full Meny",

    // Homepage Menu Categories
    home_menu_tag: "Meny",
    home_menu_title: "Utforsk Vår Meny",

    // Homepage Reviews
    home_reviews_tag: "Anmeldelser",
    home_reviews_title: "Kundeanmeldelser",

    // Homepage Booking
    home_booking_tag: "Reservasjon",
    home_booking_title: "Reserver Ditt Bord",
    home_booking_name: "Navn",
    home_booking_email: "E-post",
    home_booking_time: "Velg tid",
    home_booking_guests: "Antall gjester",
    home_booking_btn: "Bestill Nå",

    // Homepage Gallery
    home_gallery_tag: "Galleri",
    home_gallery_title: "Bildegalleri",
    home_gallery_btn: "Se Hele Galleriet",

    // Homepage Contact
    home_contact_tag: "Kontakt",
    home_contact_title: "Besøk Oss",
    home_contact_address: "Adresse",
    home_contact_hours: "Åpningstider",
    home_contact_phone: "Telefon",
    home_contact_btn: "Kontakt Oss",
    hours_mon_thu: "Man-Tor: 15:00 - 22:00",
    hours_fri_sat: "Fre-Lør: 15:00 - 23:00",
    hours_sun: "Søn: 15:00 - 22:00",

    // Menu Page
    menu_tag: "Vår Meny",
    menu_title: "Meny",
    menu_subtitle: "Opplev autentiske indiske smaker tilberedt med tradisjonelle krydder",
    menu_all: "Alle",
    menu_add: "Legg til",
    menu_choose_add: "Velg & Legg til",
    menu_choose_options: "Velg Alternativer",
    menu_meat_choice: "Velg Kjøtt",
    menu_chicken: "Kylling",
    menu_lamb: "Lam",
    menu_spice_level: "Velg Kryddernivå",
    menu_total: "Total",
    menu_add_to_cart: "Legg i Handlekurv",
    menu_cancel: "Avbryt",
    menu_added_toast: "lagt til!",
    menu_allergens: "Allergener",
    menu_takeaway: "Kun henting",
    menu_checkout: "Gå til Kasse",

    // Category names
    cat_forretter: "Forretter",
    cat_chef_special: "Kokk Spesial",
    cat_tandoori: "Tandoori",
    cat_traditional: "Tradisjonelle",
    cat_seafood: "Sjømat",
    cat_vegetar: "Vegetar",
    cat_nan: "Nan & Brød",
    cat_tilbehor: "Tilbehør",
    cat_barn: "Barn",
    cat_mains: "Hovedretter",

    // Order Page
    order_tag: "Bestilling",
    order_title: "Bestill Online",
    order_subtitle: "Kun henting - Bestill og hent hos oss",
    order_cart: "Din Handlekurv",
    order_empty: "Handlekurven din er tom",
    order_empty_desc: "Gå til menyen for å legge til retter",
    order_go_menu: "Gå til Meny",
    order_per_item: "per stk",
    order_subtotal: "Subtotal",
    order_discount: "Rabatt",
    order_total: "Totalbeløp",
    order_coupon_placeholder: "Kupongkode",
    order_apply: "Bruk",
    order_giftcard_placeholder: "Gavekort-kode",
    order_customer_info: "Kundeinformasjon",
    order_name: "Fullt Navn",
    order_email: "E-post",
    order_phone: "Telefonnummer",
    order_notes: "Bestillingsnotater (Valgfritt)",
    order_notes_placeholder: "Spesielle ønsker, allergier, etc.",
    order_payment: "Betalingsmåte",
    order_pay_online: "Betal Online (Nets)",
    order_pay_restaurant: "Betal ved Henting",
    order_place: "Legg inn Bestilling",
    order_placing: "Behandler...",
    order_busy_title: "Vi er travle akkurat nå",
    order_items: "varer",

    // Booking Page
    booking_tag: "Reservasjon",
    booking_title: "Reserver Bord",
    booking_subtitle: "Bestill ditt bord for en uforglemmelig matopplevelse",
    booking_name: "Fullt Navn",
    booking_email: "E-post",
    booking_phone: "Telefonnummer",
    booking_date: "Dato",
    booking_time: "Tid",
    booking_guests: "Gjester",
    booking_requests: "Spesielle Ønsker (Valgfritt)",
    booking_requests_placeholder: "Allergier, diettrestriksjoner, feiring, etc.",
    booking_submit: "Bestill Nå",
    booking_submitting: "Sender...",
    booking_info_title: "Reservasjonsinformasjon",
    booking_info_1: "Reservasjoner bekreftes via e-post innen 2 timer",
    booking_info_2: "Vennligst ankom innen 15 minutter etter reservasjonstiden",
    booking_info_3: "For store grupper (10+), vennligst ring oss direkte",
    booking_info_4: "Kanselleringer må gjøres 24 timer i forveien",
    booking_success: "Reservasjonsforespørsel sendt! Vi bekrefter snart via e-post.",
    booking_error: "Kunne ikke sende reservasjon. Vennligst prøv igjen.",

    // Gift Card Page
    gc_tag: "Gavekort",
    gc_title: "Kjøp Gavekort",
    gc_subtitle: "Del gleden av autentisk indisk mat med dine kjære",
    gc_step1: "1. Velg Anledning",
    gc_step2: "2. Velg Beløp",
    gc_step3: "3. Fra og Til",
    gc_step4: "4. E-post",
    gc_step5: "5. Personlig Melding (Valgfritt)",
    gc_custom: "Egendefinert:",
    gc_from: "Fra (avsender)",
    gc_from_placeholder: "Ditt navn",
    gc_to: "Til (mottaker)",
    gc_to_placeholder: "Mottakerens navn",
    gc_your_email: "Din E-post",
    gc_recipient_email: "Mottakers E-post (Valgfritt)",
    gc_recipient_email_hint: "La stå tom hvis du vil gi gavekortet selv",
    gc_message_placeholder: "Gratulerer med dagen! Nyt et deilig måltid!",
    gc_summary: "Sammendrag",
    gc_occasion_label: "Anledning:",
    gc_from_label: "Fra:",
    gc_to_label: "Til:",
    gc_valid_label: "Gyldig:",
    gc_valid_1year: "1 år fra kjøp",
    gc_total: "Totalbeløp",
    gc_buy_btn: "Kjøp Gavekort",
    gc_buying: "Behandler...",
    gc_info_title: "Gavekortinformasjon",
    gc_info_1: "Gyldig i 1 år fra kjøpsdato",
    gc_info_2: "Kan brukes for henting av mat",
    gc_info_3: "PDF med unikt design sendes på e-post",
    gc_info_4: "Inneholder QR-kode og unik gavekort-kode",
    gc_info_5: "Ikke refunderbart og kan ikke byttes mot kontanter",

    // Gift Card Occasions
    occ_none: "Ingen Anledning",
    occ_none_desc: "Indisk mat-tema",
    occ_birthday: "Bursdag",
    occ_birthday_desc: "Feiringdesign",
    occ_christmas: "Jul",
    occ_christmas_desc: "Juledesign",
    occ_easter: "Påske",
    occ_easter_desc: "Vårtema",
    occ_mothersday: "Morsdag",
    occ_mothersday_desc: "Blomsterdesign",
    occ_womensday: "Kvinnedag",
    occ_womensday_desc: "Elegant design",
    occ_occasion: "Annen Anledning",
    occ_occasion_desc: "Festlig design",

    // Gift Card Success
    gc_success_title: "Gavekort Aktivert!",
    gc_success_subtitle: "Ditt gavekort er opprettet og klart til bruk.",
    gc_success_code: "Din Gavekort-kode",
    gc_success_download: "Last Ned Gavekort (PDF)",
    gc_success_pdf_hint: "PDF-en inneholder ditt personlige gavekort med QR-kode. Lagre eller skriv ut den!",
    gc_success_how: "Slik Bruker Du Gavekortet",
    gc_success_how_1: "Bruk koden ved bestilling for å trekke fra beløpet",
    gc_success_how_2: "Gyldig i 1 år fra kjøpsdato",
    gc_success_how_3: "Kan brukes for henting av mat",
    gc_success_how_4: "Saldo kan sjekkes ved å bruke koden ved kassen",
    gc_success_use_now: "Bruk Gavekort Nå",
    gc_success_home: "Tilbake til Forsiden",

    // Gallery Page
    gallery_tag: "Galleri",
    gallery_title: "Bildegalleri",
    gallery_subtitle: "En visuell reise gjennom våre smaker og atmosfære",
    gallery_all: "Alle Bilder",
    gallery_food: "Mat",
    gallery_restaurant: "Restaurant",
    gallery_loading: "Laster galleri...",

    // About Page
    about_tag: "Om Oss",
    about_title: "Om Masala Indisk",
    about_subtitle: "Vår historie og lidenskap for autentisk indisk mat",
    about_story_tag: "Vår Historie",
    about_story_title: "En Reise Gjennom Smaker",
    about_story_p1: "Masala Indisk ble grunnlagt med et enkelt oppdrag: å bringe de autentiske smakene av tradisjonell indisk mat til Norge. Vår reise begynte da kokk Rajesh Kumar, som trente i kjøkkenene i Mumbai og Delhi, bestemte seg for å dele sin lidenskap for indiske kulinariske tradisjoner med det norske samfunnet.",
    about_story_p2: "I dag er vi stolte av å servere autentiske indiske retter tilberedt med tradisjonelle oppskrifter, importerte krydder og de ferskeste lokale ingrediensene. Hver rett forteller en historie om Indias rike kulinariske arv, laget med kjærlighet og dedikasjon.",
    about_chef_tag: "Vår Kokk",
    about_chef_title: "Møt Vår Hovedkokk",
    about_chef_name: "Kokk Rajesh Kumar",
    about_chef_desc: "Med over 20 års kulinarisk erfaring bringer kokk Rajesh autentiske indiske smaker til hver rett. Trent i de tradisjonelle kokkemetodene fra Nord-India, har han mestret kunsten å balansere krydder og lage retter som ærer Indias rike kulinariske arv.",
    about_chef_exp: "20+ Års Erfaring",
    about_chef_skill: "Mester av Krydder",
    about_values_tag: "Verdier",
    about_values_title: "Våre Verdier",
    about_val_auth: "Autentisitet",
    about_val_auth_desc: "Vi holder oss til tradisjonelle indiske oppskrifter og kokemetoder",
    about_val_comm: "Fellesskap",
    about_val_comm_desc: "Vi samler folk gjennom det universelle språket mat",
    about_val_qual: "Kvalitet",
    about_val_qual_desc: "Bare de fineste ingrediensene og ferskeste krydderiene i hver rett",
    about_cta_title: "Opplev Vår Tradisjon",
    about_cta_desc: "Besøk oss i dag og smak forskjellen som autentisitet gjør",

    // Contact Page
    contact_tag: "Kontakt",
    contact_title: "Kontakt Oss",
    contact_subtitle: "Vi gleder oss til å høre fra deg",
    contact_form_title: "Send Oss en Melding",
    contact_name: "Navn",
    contact_email: "E-post",
    contact_phone: "Telefon",
    contact_subject: "Emne",
    contact_subject_placeholder: "Catering, reservasjon, tilbakemelding, etc.",
    contact_message: "Melding",
    contact_send: "Send Melding",
    contact_sending: "Sender...",
    contact_info_title: "Kontaktinformasjon",
    contact_find: "Finn Oss",
    contact_success: "Melding sendt! Vi kontakter deg snart.",

    // Catering Page
    catering_tag: "Catering",
    catering_title: "Catering Tjenester",
    catering_subtitle: "Ta med den autentiske smaken av India til dine spesielle arrangementer",
    catering_events_tag: "Arrangementer",
    catering_events_title: "Perfekt for Enhver Anledning",
    catering_wedding: "Bryllup",
    catering_corporate: "Bedriftsarrangementer",
    catering_birthday: "Bursdagsfester",
    catering_private: "Private Arrangementer",
    catering_menus_tag: "Menyer",
    catering_menus_title: "Eksempel Cateringmenyer",
    catering_menus_subtitle: "Kan tilpasses dine preferanser",
    catering_cta_title: "Klar til å Planlegge Ditt Arrangement?",
    catering_cta_desc: "Kontakt oss for tilpassede menyer og priser • Minimum 15 gjester",
    catering_info_title: "Cateringinformasjon",
    catering_info_1: "Minimumsbestilling: 15 gjester",
    catering_info_2: "Forhåndsbestilling påkrevd (minimum 48 timer)",
    catering_info_3: "Gratis levering innen 15 km fra Oslo",
    catering_info_4: "Vegetariske og veganske alternativer tilgjengelig",
    catering_info_5: "Oppsett- og ryddetjeneste tilgjengelig",
    catering_info_6: "Halal kjøttalternativer",
    catering_corporate_menu: "Bedriftsarrangement",
    catering_wedding_menu: "Bryllupsfest",
    catering_party_menu: "Festpakke",
    catering_serves: "gjester",
    catering_per_person: "per person",

    // Footer
    footer_desc: "Autentisk indisk mat med rike smaker og aromaer fra India.",
    footer_links: "Hurtiglenker",
    footer_hours: "Åpningstider",
    footer_contact: "Kontakt Oss",
    footer_rights: "Alle rettigheter reservert.",

    // Common
    loading: "Laster...",
    error: "Noe gikk galt",
    per_person: "per person",
  },

  en: {
    // Navbar
    nav_menu: "Menu",
    nav_order: "Order",
    nav_booking: "Reservation",
    nav_catering: "Catering",
    nav_giftcard: "Gift Card",
    nav_gallery: "Gallery",
    nav_about: "About Us",
    nav_contact: "Contact",

    // Homepage Hero
    hero_subtitle: "Taste of India",
    hero_menu_btn: "View Menu",
    hero_booking_btn: "Reserve Table",

    // Homepage About
    home_about_tag: "About Us",
    home_about_title: "Experience the True Taste of India",
    home_about_p1: "Welcome to Masala Indisk Restaurant og Bar – where tradition, spices and passion come together. We serve authentic dishes made with the finest ingredients and timeless recipes from the Indian kitchen.",
    home_about_p2: "With over 30 years of experience, we invite you on a culinary journey through India – where every dish is made with love, precision and pride.",

    // Homepage Popular
    home_popular_tag: "Popular Dishes",
    home_popular_title: "Our Popular Dishes",
    home_popular_explore: "Explore Full Menu",

    // Homepage Menu Categories
    home_menu_tag: "Menu",
    home_menu_title: "Explore Our Menu",

    // Homepage Reviews
    home_reviews_tag: "Reviews",
    home_reviews_title: "Customer Reviews",

    // Homepage Booking
    home_booking_tag: "Reservation",
    home_booking_title: "Reserve Your Table",
    home_booking_name: "Name",
    home_booking_email: "Email",
    home_booking_time: "Select time",
    home_booking_guests: "Number of guests",
    home_booking_btn: "Book Now",

    // Homepage Gallery
    home_gallery_tag: "Gallery",
    home_gallery_title: "Photo Gallery",
    home_gallery_btn: "View Full Gallery",

    // Homepage Contact
    home_contact_tag: "Contact",
    home_contact_title: "Visit Us",
    home_contact_address: "Address",
    home_contact_hours: "Opening Hours",
    home_contact_phone: "Phone",
    home_contact_btn: "Contact Us",
    hours_mon_thu: "Mon-Thu: 15:00 - 22:00",
    hours_fri_sat: "Fri-Sat: 15:00 - 23:00",
    hours_sun: "Sun: 15:00 - 22:00",

    // Menu Page
    menu_tag: "Our Menu",
    menu_title: "Menu",
    menu_subtitle: "Experience authentic Indian flavours prepared with traditional spices",
    menu_all: "All",
    menu_add: "Add",
    menu_choose_add: "Choose & Add",
    menu_choose_options: "Choose Options",
    menu_meat_choice: "Choose Meat",
    menu_chicken: "Chicken",
    menu_lamb: "Lamb",
    menu_spice_level: "Choose Spice Level",
    menu_total: "Total",
    menu_add_to_cart: "Add to Cart",
    menu_cancel: "Cancel",
    menu_added_toast: "added!",
    menu_allergens: "Allergens",
    menu_takeaway: "Pickup only",
    menu_checkout: "Go to Checkout",

    // Category names
    cat_forretter: "Starters",
    cat_chef_special: "Chef's Special",
    cat_tandoori: "Tandoori",
    cat_traditional: "Traditional",
    cat_seafood: "Seafood",
    cat_vegetar: "Vegetarian",
    cat_nan: "Nan & Bread",
    cat_tilbehor: "Sides",
    cat_barn: "Kids",
    cat_mains: "Main Courses",

    // Order Page
    order_tag: "Order",
    order_title: "Order Online",
    order_subtitle: "Pickup only - Order and collect from us",
    order_cart: "Your Cart",
    order_empty: "Your cart is empty",
    order_empty_desc: "Go to the menu to add dishes",
    order_go_menu: "Go to Menu",
    order_per_item: "per item",
    order_subtotal: "Subtotal",
    order_discount: "Discount",
    order_total: "Total",
    order_coupon_placeholder: "Coupon code",
    order_apply: "Apply",
    order_giftcard_placeholder: "Gift card code",
    order_customer_info: "Customer Information",
    order_name: "Full Name",
    order_email: "Email",
    order_phone: "Phone Number",
    order_notes: "Order Notes (Optional)",
    order_notes_placeholder: "Special requests, allergies, etc.",
    order_payment: "Payment Method",
    order_pay_online: "Pay Online (Nets)",
    order_pay_restaurant: "Pay at Pickup",
    order_place: "Place Order",
    order_placing: "Processing...",
    order_busy_title: "We are busy right now",
    order_items: "items",

    // Booking Page
    booking_tag: "Reservation",
    booking_title: "Reserve a Table",
    booking_subtitle: "Book your table for an unforgettable dining experience",
    booking_name: "Full Name",
    booking_email: "Email",
    booking_phone: "Phone Number",
    booking_date: "Date",
    booking_time: "Time",
    booking_guests: "Guests",
    booking_requests: "Special Requests (Optional)",
    booking_requests_placeholder: "Allergies, dietary restrictions, celebrations, etc.",
    booking_submit: "Book Now",
    booking_submitting: "Sending...",
    booking_info_title: "Reservation Information",
    booking_info_1: "Reservations are confirmed via email within 2 hours",
    booking_info_2: "Please arrive within 15 minutes of your reservation time",
    booking_info_3: "For large groups (10+), please call us directly",
    booking_info_4: "Cancellations must be made 24 hours in advance",
    booking_success: "Reservation request sent! We will confirm shortly via email.",
    booking_error: "Could not send reservation. Please try again.",

    // Gift Card Page
    gc_tag: "Gift Card",
    gc_title: "Buy Gift Card",
    gc_subtitle: "Share the joy of authentic Indian food with your loved ones",
    gc_step1: "1. Choose Occasion",
    gc_step2: "2. Choose Amount",
    gc_step3: "3. From and To",
    gc_step4: "4. Email",
    gc_step5: "5. Personal Message (Optional)",
    gc_custom: "Custom:",
    gc_from: "From (sender)",
    gc_from_placeholder: "Your name",
    gc_to: "To (recipient)",
    gc_to_placeholder: "Recipient's name",
    gc_your_email: "Your Email",
    gc_recipient_email: "Recipient's Email (Optional)",
    gc_recipient_email_hint: "Leave empty if you want to give the card yourself",
    gc_message_placeholder: "Happy birthday! Enjoy a delicious meal!",
    gc_summary: "Summary",
    gc_occasion_label: "Occasion:",
    gc_from_label: "From:",
    gc_to_label: "To:",
    gc_valid_label: "Valid:",
    gc_valid_1year: "1 year from purchase",
    gc_total: "Total Amount",
    gc_buy_btn: "Buy Gift Card",
    gc_buying: "Processing...",
    gc_info_title: "Gift Card Information",
    gc_info_1: "Valid for 1 year from date of purchase",
    gc_info_2: "Can be used for food pickup",
    gc_info_3: "PDF with unique design sent via email",
    gc_info_4: "Contains QR code and unique gift card code",
    gc_info_5: "Non-refundable and cannot be exchanged for cash",

    // Gift Card Occasions
    occ_none: "No Occasion",
    occ_none_desc: "Indian food theme",
    occ_birthday: "Birthday",
    occ_birthday_desc: "Celebration design",
    occ_christmas: "Christmas",
    occ_christmas_desc: "Holiday design",
    occ_easter: "Easter",
    occ_easter_desc: "Spring theme",
    occ_mothersday: "Mother's Day",
    occ_mothersday_desc: "Floral design",
    occ_womensday: "Women's Day",
    occ_womensday_desc: "Elegant design",
    occ_occasion: "Other Occasion",
    occ_occasion_desc: "Festive design",

    // Gift Card Success
    gc_success_title: "Gift Card Activated!",
    gc_success_subtitle: "Your gift card is created and ready to use.",
    gc_success_code: "Your Gift Card Code",
    gc_success_download: "Download Gift Card (PDF)",
    gc_success_pdf_hint: "The PDF contains your personal gift card with QR code. Save or print it!",
    gc_success_how: "How to Use Your Gift Card",
    gc_success_how_1: "Use the code when ordering to deduct the amount",
    gc_success_how_2: "Valid for 1 year from date of purchase",
    gc_success_how_3: "Can be used for food pickup",
    gc_success_how_4: "Balance can be checked using the code at checkout",
    gc_success_use_now: "Use Gift Card Now",
    gc_success_home: "Back to Home",

    // Gallery Page
    gallery_tag: "Gallery",
    gallery_title: "Photo Gallery",
    gallery_subtitle: "A visual journey through our flavours and atmosphere",
    gallery_all: "All Photos",
    gallery_food: "Food",
    gallery_restaurant: "Restaurant",
    gallery_loading: "Loading gallery...",

    // About Page
    about_tag: "About Us",
    about_title: "About Masala Indisk",
    about_subtitle: "Our story and passion for authentic Indian food",
    about_story_tag: "Our Story",
    about_story_title: "A Journey Through Flavours",
    about_story_p1: "Masala Indisk was founded with a simple mission: to bring the authentic flavours of traditional Indian food to Norway. Our journey began when Chef Rajesh Kumar, trained in the kitchens of Mumbai and Delhi, decided to share his passion for Indian culinary traditions with the Norwegian community.",
    about_story_p2: "Today, we are proud to serve authentic Indian dishes prepared with traditional recipes, imported spices, and the freshest local ingredients. Every dish tells a story of India's rich culinary heritage, made with love and dedication.",
    about_chef_tag: "Our Chef",
    about_chef_title: "Meet Our Head Chef",
    about_chef_name: "Chef Rajesh Kumar",
    about_chef_desc: "With over 20 years of culinary experience, Chef Rajesh brings authentic Indian flavours to every dish. Trained in the traditional cooking methods of North India, he has mastered the art of balancing spices and creating dishes that honour India's rich culinary heritage.",
    about_chef_exp: "20+ Years Experience",
    about_chef_skill: "Master of Spices",
    about_values_tag: "Values",
    about_values_title: "Our Values",
    about_val_auth: "Authenticity",
    about_val_auth_desc: "We stay true to traditional Indian recipes and cooking methods",
    about_val_comm: "Community",
    about_val_comm_desc: "We bring people together through the universal language of food",
    about_val_qual: "Quality",
    about_val_qual_desc: "Only the finest ingredients and freshest spices in every dish",
    about_cta_title: "Experience Our Tradition",
    about_cta_desc: "Visit us today and taste the difference that authenticity makes",

    // Contact Page
    contact_tag: "Contact",
    contact_title: "Contact Us",
    contact_subtitle: "We look forward to hearing from you",
    contact_form_title: "Send Us a Message",
    contact_name: "Name",
    contact_email: "Email",
    contact_phone: "Phone",
    contact_subject: "Subject",
    contact_subject_placeholder: "Catering, reservation, feedback, etc.",
    contact_message: "Message",
    contact_send: "Send Message",
    contact_sending: "Sending...",
    contact_info_title: "Contact Information",
    contact_find: "Find Us",
    contact_success: "Message sent! We will contact you shortly.",

    // Catering Page
    catering_tag: "Catering",
    catering_title: "Catering Services",
    catering_subtitle: "Bring the authentic taste of India to your special events",
    catering_events_tag: "Events",
    catering_events_title: "Perfect for Any Occasion",
    catering_wedding: "Weddings",
    catering_corporate: "Corporate Events",
    catering_birthday: "Birthday Parties",
    catering_private: "Private Events",
    catering_menus_tag: "Menus",
    catering_menus_title: "Sample Catering Menus",
    catering_menus_subtitle: "Can be customised to your preferences",
    catering_cta_title: "Ready to Plan Your Event?",
    catering_cta_desc: "Contact us for customised menus and prices • Minimum 15 guests",
    catering_info_title: "Catering Information",
    catering_info_1: "Minimum order: 15 guests",
    catering_info_2: "Pre-order required (minimum 48 hours)",
    catering_info_3: "Free delivery within 15 km from Oslo",
    catering_info_4: "Vegetarian and vegan options available",
    catering_info_5: "Setup and cleanup service available",
    catering_info_6: "Halal meat options",
    catering_corporate_menu: "Corporate Event",
    catering_wedding_menu: "Wedding Celebration",
    catering_party_menu: "Party Package",
    catering_serves: "guests",
    catering_per_person: "per person",

    // Footer
    footer_desc: "Authentic Indian food with rich flavours and aromas from India.",
    footer_links: "Quick Links",
    footer_hours: "Opening Hours",
    footer_contact: "Contact Us",
    footer_rights: "All rights reserved.",

    // Common
    loading: "Loading...",
    error: "Something went wrong",
    per_person: "per person",
  },
};
